export default __webpack_public_path__ + "static/media/26t.afebaea8.jpg";